<template>
	<SliderPanel
		v-if="type == 'slideshow'"
		:title="headerTitle"
		headerStyle="slideshow"
		:modal="true"
		size="full"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
	<div class="p-3">
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</div>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'lngReviewEdit' && configcollection?.id != 'language_review'"
		:title="headerTitle"
		headerStyle="lngReviewEdit"
		:modal="true"
		size="lngReviewEdit"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>	
			<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh);"></iframe>
	</SliderPanel>

	<SliderPanel
		v-else-if="type == 'slideshowEdit'"
		:title="headerTitle"
		headerStyle="slideshowEdit"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'print'"
		:title="headerTitle"
		headerStyle="print"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'feedback'"
		:title="headerTitle"
		headerStyle="feedback"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'notification'"
		:title="headerTitle"
		headerStyle="notification"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe id="notifyIframe" :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 56px);"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'imagelist'"
		:title="headerTitle"
		headerStyle="dark"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'imageattr'"
		:title="headerTitle"
		headerStyle="dark"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'listattr' || type == 'details' || type == 'prequiz' || type == 'assessment' || type == 'podcast' || type == 'new' || type == 'newmodels' || type == 'editmodels' || type == 'inputResources' || type == 'newImage'  || type == 'editPackage'"
		:title="headerTitle"
		headerStyle="dark"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'postquiz' || type == 'references' || type == 'podcast'"
		:title="headerTitle"
		headerStyle="dark"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height:calc( 100vh - 18px)" ></iframe>
	</SliderPanel>

	<SliderPanel v-else-if="type != 'finishassistantMode' && type != 'configButtonMode' && type != 'listattr' && type != 'assistantMode' && type != 'complainceAssistantMode' && type != 'helpSupportAssistant' && type != 'reportassistantMode' && type != 'examinerAssistantMode' && type != 'readCallAssistantButton' && type != 'feedbackAssistantMode' && type != 'print'" :title="headerTitle" headerStyle="dark" :dismissable="false" @closed="emit('closed')" :size="panelSize" :icon="iconHeader">
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden" style="max-height: calc(100vh - 85px);"></iframe>
	</SliderPanel>

	<SliderPanel
		v-else-if="type == 'finishassistantMode' || type == 'configButtonMode' || type == 'assistantMode' "
		:title="headerTitle"
		headerStyle="author"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'complainceAssistantMode'"
		:title="headerTitle"
		headerStyle="author"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'helpSupportAssistant'"
		:title="headerTitle"
		headerStyle="author"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'feedbackAssistantMode'"
		:title="headerTitle"
		headerStyle="feedback"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'reportassistantMode'"
		:title="headerTitle"
		headerStyle="author"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'examinerAssistantMode'"
		:title="headerTitle"
		headerStyle="author"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>
	<SliderPanel
		v-else-if="type == 'readCallAssistantButton'"
		:title="headerTitle"
		headerStyle="readCallAssistant"
		:size="panelSize"
		:icon="iconHeader"
		:dismissable="false" @closed="emit('closed')"
	>
		<iframe :src="iframeUrl" class="w-full h-100vh overflow-hidden"></iframe>
	</SliderPanel>

</template>
<script setup lang="ts">
import { defineProps } from 'vue';
import SliderPanel from '../components/SidebarPanel/SidebarPanel.vue';
import { messages } from '@/assets/language'
import { useAppStore } from '@/stores/app-store'
import {useAppConfig} from '@/composables/useAppConfig';
import type { configCollectionMode } from '@/types';

const { currentLng, currentCollectionMode, currentTestyourself, currentPAGE_REQ_ID } = useAppStore()

const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
} )

const emit = defineEmits<{
  (e: 'closed'): void
}>()

const props = defineProps<{
	id: string | null;
	type: string | null;
	headerStyle?: string;
	overrideURL?: string;
	headerTitle?: string;
	size?: string;
	configcollection: configCollectionMode | null

}>();

const AppConfig = useAppConfig();

const getListBaseUrl = () => {
	const raw = String(AppConfig.urls.getList ?? '').trim()
	if (!raw) {
		return ''
	}

	try {
		const url = new URL(raw, window.location.origin)
		url.search = ''
		url.hash = ''
		return url.toString().replace(/\/$/, '')
	} catch {
		return raw.replace(/[?#].*$/, '').replace(/\/$/, '')
	}
}
const allowedSizes = ['lngReviewEdit', 'xxl', 'xl', 'sm', 'md', 'lg', 'full'] as const;
type AllowedSize = typeof allowedSizes[number];

const panelSize = computed<AllowedSize | undefined>(() => {
  if (allowedSizes.includes(props.size as AllowedSize)) {
    return props.size as AllowedSize;
  }

  switch (props.type) {
    case 'slideshow':
      return 'full';
    case 'lngReviewEdit':
      return 'full';
    default:
      return 'xl';
  }
});

const applyDetailsContext = (rawUrl: string) => {
	const resolveTargetLng = () => {
		try {
			const parsedUrl = new URL(rawUrl, window.location.origin)
			const explicitLng = String(parsedUrl.searchParams.get('lng') ?? '').trim()
			if (explicitLng) {
				return explicitLng
			}
		} catch {
			// no-op, fallback below
		}
		return String(currentLng.value ?? '').trim()
	}

	const targetLng = resolveTargetLng()

	try {
		const url = new URL(rawUrl, window.location.origin)
		url.searchParams.set('json', 'y')
		url.searchParams.set('mode', 'details')
		if (targetLng) {
			url.searchParams.set('lng', targetLng)
		}
		if (currentCollectionMode.value) {
			url.searchParams.set('collection-mode', String(currentCollectionMode.value))
		}
		if (currentTestyourself.value) {
			url.searchParams.set('testYourself', String(currentTestyourself.value))
		}
		if (currentPAGE_REQ_ID.value) {
			url.searchParams.set('PAGE_REQ_ID', String(currentPAGE_REQ_ID.value))
		}
		return url.toString()
	} catch {
		const params = new URLSearchParams({
			json: 'y',
			mode: 'details',
		})
		if (targetLng) {
			params.set('lng', targetLng)
		}
		if (currentCollectionMode.value) {
			params.set('collection-mode', String(currentCollectionMode.value))
		}
		if (currentTestyourself.value) {
			params.set('testYourself', String(currentTestyourself.value))
		}
		if (currentPAGE_REQ_ID.value) {
			params.set('PAGE_REQ_ID', String(currentPAGE_REQ_ID.value))
		}
		const separator = rawUrl.includes('?') ? '&' : '?'
		return `${rawUrl}${separator}${params.toString()}`
	}
}

const detailsUrlForPrint = computed(() => {
	if (props.overrideURL) {
		return applyDetailsContext(props.overrideURL)
	}

	if (!props.id) {
		return ''
	}

	const baseApi = getListBaseUrl()
	if (!baseApi) {
		return ''
	}

	return applyDetailsContext(`${baseApi}/${encodeURIComponent(String(props.id))}`)
})

const detailsLngForPrint = computed(() => {
	const rawUrl = String(detailsUrlForPrint.value ?? '').trim()
	if (!rawUrl) {
		return String(currentLng.value ?? '')
	}
	try {
		const parsed = new URL(rawUrl, window.location.origin)
		const explicitLng = String(parsed.searchParams.get('lng') ?? '').trim()
		if (explicitLng) {
			return explicitLng
		}
	} catch {
		// fallback below
	}
	return String(currentLng.value ?? '')
})

const PrintRoute = computed(() => {
	const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : '#/'
	const queryParams = new URLSearchParams({
		lng: String(detailsLngForPrint.value ?? currentLng.value ?? '')
	})

	if (detailsUrlForPrint.value) {
		queryParams.set('detailsUrl', detailsUrlForPrint.value)
	}

	return `${baseUrl}print/${props.id}?${queryParams.toString()}`
})
const presentationRoute = computed(() => {
	const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : '#/'
	return `${baseUrl}details/${props.id}/presenation?lng=${currentLng.value}`;
})

const iconHeader = computed(() => {
	switch (props.type) {
		case 'new':
			return 'tabler:plus';
		case 'models':
			return 'tabler:plus';
		case 'inputResources':
			return 'tabler:plus';
		case 'mainOutcome':
			return 'tabler:plus';
		case 'newImage':
			return 'tabler:photo-plus';
		case 'listattr':
			return 'tabler:list';
		case 'imageattr':
			return 'tabler:photo';
		case 'details':
			return 'tabler:file-description ';
		case 'references':
			return 'tabler:link';
		case 'podcast':
			return 'tabler:brand-apple-podcast';
		case 'prequiz':
			return 'tabler:message-question';
		case 'assessment':
			return 'tabler:clipboard-check';
		case 'postquiz':
			return 'tabler:message-question ';
		case 'slideshow':
			return 'tabler:presentation ';
		case 'lngReviewEdit':
			return 'tabler:presentation ';
		case 'askAssistant':
			return 'tabler:message-2-question ';
		case 'finishassistantMode':
			return 'tabler:message-2-question ';
		case 'feedback':
			return 'tabler:message-2-question ';
		case 'notification':
			return 'tabler:bell-ringing';
		case 'feedbackList':
			return 'tabler:message-user';
		case 'print':
			return 'tabler:printer';
		default:
			return 'tabler:settings';
	}
});
const headerTitle = computed(() => {
	if (props.headerTitle) return props.headerTitle
	switch (props.type) {
		case 'new':
			return 'New WI (Package)';
		case 'newmodels':
			return 'Add/Edit WI (Model)';
		case 'inputResources':
			return 'New WI (Working Item)';
		case 'mainOutcome':
			return 'Main Outcome';
		case 'newImage':
			return 'Add new illustration';
		case 'listattr':
			return 'Modify List Attributes';
		case 'imagelist':
			return 'Modify Image List Attributes';
		case 'imageattr':
			return 'Modify Image Attributes';
		case 'details':
			return 'Modify Details Attributes ';
		case 'references':
			return 'Modify References Attributes';
		case 'podcast':
			return 'Modify Podcast Attributes';
		case 'prequiz':
			return 'Modify Pre Quiz Attributes';
		case 'assessment':
			return 'Modify Assessment Attributes';
		case 'postquiz':
			return 'Modify Post Quiz Attributes ';
		case 'slideshow':
			return 'Add New Overall Slideshow';
		case 'slideshowEdit':
			return 'Modify Slideshow/Podcast Attributes';
		case 'lngReviewEdit':
			return 'Language Reviewer Mode';
		case 'editPackage':
			return 'Modify Package';
		case 'askAssistant':
			return 'Ask Assistant';
		case 'finishassistantMode':
			return 'Recall (Workflow state) Personal Assistant';
		case 'configAssistantMode':
			return 'Configure Assistant';
		case 'complainceAssistantMode':
			return 'Re(call) Compliancy Assistant!';
		case 'assistantMode':
			return '[Author] Personal Assistant <-> [UserName] - [Next Workflow State]';
		case 'helpSupportAssistant':
			return props.headerTitle;
		case 'reportassistantMode':
			return 'Ask Reporting Assistant';
		case 'feedbackAssistantMode':
			return 'Feedback Assistant';
		case 'callAssistantMode':
			return 'Ask Call Assistant';
		case 'readCallAssistantButton':
			return props.headerTitle;
		case 'feedback':
			return labels.value.leavefeedbackmsg;
		case 'feedbackList':
			return 'Feedbacks list written for this Review Post';
		case 'print':
			return 'Print';
		case 'notification':
			return props.headerTitle;
		default:
			return 'Default Title';
	}
});
const iframeUrl = computed(() => {
	if (props.overrideURL && props.type !== 'print') {
		return props.overrideURL;
	}
	switch (props.type) {
		case 'new':
			return AppConfig.urls.newPackage;
		case 'newmodels':
			return AppConfig.urls.newmodels;
		case 'editmodels':
			return AppConfig.urls.editmodels;
		case 'inputResources':
			return AppConfig.urls.inputResources;
		case 'mainOutcome':
			return AppConfig.urls.inputResources;
		case 'newImage':
			return AppConfig.urls.inputIllutration;
		case 'listattr':
			return AppConfig.urls.editPackage;
		case 'imagelist':
			return AppConfig.urls.editIllutration;
		case 'imageattr':
			return AppConfig.urls.editIllutration;
		case 'details':
			return AppConfig.urls.editDetails;
		case 'references':
			return AppConfig.urls.inputResources;
		case 'podcast':
			return AppConfig.urls.editPodcast;
		case 'prequiz':
			return AppConfig.urls.editPrequiz;
		case 'assessment':
			return AppConfig.urls.editPrequiz;
		case 'postquiz':
			return AppConfig.urls.editPostquiz;
		case 'slideshowEdit':
			return AppConfig.urls.editSlideshow;
		case 'slideshowEditFull':
			return AppConfig.urls.editSlideshow;
		case 'askAssistant':
			return AppConfig.urls.inputResources;
		case 'readCallAssistantButton':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'feedback':
			return AppConfig.urls.feedback?.url;
		case 'feedbackList':
			return AppConfig.urls.feedback?.listUrl;
		case 'finishassistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'complainceAssistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'helpSupportAssistant':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'reportassistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'callAssistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'configButtonMode':
			return AppConfig.urls.assistantModeButtons?.configButton.configAssistantLink;
		case 'assistantMode':
			return AppConfig.urls.assistantModeButtons?.finishButton.finishAssistantLink;
		case 'print':
		    return PrintRoute.value
		case 'slideshow':
		    return presentationRoute.value
		default:
			return AppConfig.urls.newPackage;
	}
});
</script>
<style scoped lang="scss">
.p-component-overlay-enter-animation .animation {
    background-color: rgba(0, 0, 0, 0.4);
}

</style>
